import type { ReactNode } from 'react'
import { cn, inputClass, labelClass } from '../../lib/ui'

type Props = {
  label: ReactNode
  htmlFor?: string
  children: ReactNode
  className?: string
}

export function FormField({ label, htmlFor, children, className }: Props) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={htmlFor} className={labelClass}>
        {label}
      </label>
      {children}
    </div>
  )
}

export function formInputProps(className?: string) {
  return { className: cn(inputClass, className) }
}
